module.exports = {
  ACTIVE: "active",
  FREETRIAL: "trialing",
  CANCELED: "canceled",
};
